module.exports = __webpack_public_path__ + "img/test.893fc153.png";